import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";

const ComingSoon = () => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid id="loginGrid">
          <IonRow id="loginRow">
            <IonCol id="loginMainContainer" size="12" size-md="6" offset-md="3">
              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <p>Coming Soon...</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default ComingSoon;
